import { normalizeState, currentCommercial } from "./commercial.mjs";
import { todayParis, addBusinessDays } from "../utils/calendar.mjs";
import { initialClients } from "../data.js";
export const storageKey = "jm-commercial-v3";
export function initialState(clients = initialClients, now = new Date()) {
  const date = todayParis(now);
  return normalizeState({
    version: 3,
    clients,
    signals: clients
      .filter((c) => c.signal)
      .map((c) => ({
        id: `signal-${c.id}`,
        clientId: c.id,
        establishment_id: c.id,
        source: c.source || "France Travail",
        date: c.signalDate?.split("/").reverse().join("-") || date,
        job: c.id === 1 ? "Aide-soignant" : c.signal,
        qty: c.id === 1 ? 5 : null,
        content: c.signal,
        importedAt: now.toISOString(),
        status: "nouveau",
      })),
    tasks: clients
      .filter((c) => !c.closed)
      .map((c) => ({
        id: `call-${c.id}`,
        clientId: c.id,
        title:
          c.kind === "prospect" ? "Premier contact" : "Réactiver le client",
        category: "call",
        due_date_original: addBusinessDays(date, 0),
        scheduled_date: addBusinessDays(date, 0),
        postponement_count: 0,
        done: false,
        ownerId: c.ownerId || currentCommercial.id,
        agency: c.agency || "Toulouse",
      })),
    needs: clients.some((c) => c.id === 4)
      ? [
          {
            id: "need-demo",
            clientId: 4,
            client: "Résidence Bellevue",
            job: "ASH",
            qty: 4,
            type: "CDD",
            start: "2026-12-01",
            status: "devis à créer",
            createdAt: now.toISOString(),
          },
        ]
      : [],
    quotes: [],
    results: [],
    events: [],
    recruitmentNeeds: [],
    engagements: [],
    imports: [],
    calendar: { closures: [] },
    pendingResultClientId: null,
    dailyCallGoal: 24,
  });
}
export function loadState() {
  try {
    const raw =
      localStorage.getItem(storageKey) ||
      localStorage.getItem("jm-commercial-v2");
    if (raw) {
      const saved = JSON.parse(raw);
      if (Array.isArray(saved.clients) && saved.clients.length) {
        // Merge only missing demo establishments; preserve every saved identifier and business record.
        for (const c of initialClients)
          if (
            !saved.clients.some((x) => x.siret === c.siret || x.name === c.name)
          )
            saved.clients.push(
              saved.clients.some((x) => x.id === c.id)
                ? { ...c, id: crypto.randomUUID() }
                : c,
            );
        const next = normalizeState(saved);
        for (const n of next.needs)
          if (!n.clientId)
            n.clientId =
              next.clients.find((c) => c.name === n.client)?.id || null;
        return next;
      }
    }
  } catch {}
  return initialState();
}
export function saveState(state) {
  localStorage.setItem(storageKey, JSON.stringify(state));
}
// API adapter boundary: merge an existing JM INTERIM base before commercial work.
export function mergeExistingEstablishments(state, existing) {
  const clients = [...state.clients];
  for (const incoming of existing) {
    const index = clients.findIndex(
      (c) =>
        c.siret === incoming.siret ||
        c.establishment_id === (incoming.establishment_id ?? incoming.id),
    );
    if (index < 0) {
      clients.push(incoming);
      continue;
    }
    const current = clients[index];
    const contacts = [...(incoming.contacts || [])];
    for (const contact of current.contacts || [])
      if (!contacts.some((c) => c.id === contact.id)) contacts.push(contact);
    clients[index] = {
      ...current,
      ...incoming,
      id: current.id,
      establishment_id:
        incoming.establishment_id ?? incoming.id ?? current.establishment_id,
      client_id: incoming.client_id ?? current.client_id,
      contacts,
      history: [...new Set([...(incoming.history || []), ...current.history])],
    };
  }
  return normalizeState({ ...state, clients });
}
